import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage, useField } from "formik";
import * as Yup from "yup";
import styles from "./legalContract.module.css";
import { Submit } from "../../../../components/button/buttons";
import IMAGES from "../../../../assets/images/images";
import FileUploadAttachment from "../../../../components/fileUpload/fileUpload.container"
import { useParams } from "react-router-dom";
import { DEMAND_ACTIONS } from "../../../../utils/constants/DemandConstant";
import { ConfirmDialog } from "../../../../hooks/confirmDialog/confirmDialog";
import { connect } from "react-redux";
import { addDemandAction } from "../../../../redux/actions/demand/demand.action";
import { openAlertPopup } from "../../../../redux/actions/Alert/alert.action";

const ImageUpload = ({ setFieldValue, value, label, feasibility, data, ...props }) => {
    const [field, meta, helpers] = useField(props);
    const hasError = meta.touched && meta.error ? true : false;
    return (
        <div >
            {/* <div style={{ display: "flex" }}><Label text={label} optional={false} />  <Asterisk /></div> */}
            <FileUploadAttachment
                setFieldValue={setFieldValue}
                name={props.name}
                value={value}
                note={false}
                displayMessage={"Upload limit: 1 file, up to 5 MB."}
                maxFileSize={5 * 1024 * 1024} //5MB
                maxFileSizeTXT={"5MB"}
                combineFilesMaxSize={5 * 1024 * 1024}
                combineFilesMaxSizeTXT={"Combined file size exceeds the 5MB limit"}
                numOfFilesAllowToUpload={1}
                errorMessageForNumberOfFiles={"You can upload max 1 file."}
                acceptFileType={
                    {    
                    'image/*': ['.jpeg','.png',],
                    'application/pdf': ['.pdf'],
                    'application/vnd.ms-excel': ['.xls',],
                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':['.xlsx'],
                    'application/msword':['.doc'],
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document':['.docx']
                    }
                }
            />
            {/* {hasError ? <ErrorLabel text={meta.error} /> : null} */}
        </div>
    );
};


const LegalContract = ({ handelServiceDetailapi, ...props }) => {
    const [isSubmit, setIsSubmit] = useState(false);
    let { requestId } = useParams();

    const validationSchema = Yup.object({
        files: Yup.array().min(1, "File is required"),
    });

    return (
        <>
        <div className={styles.container}>
            <Formik
                initialValues={{ files: [] }}
                validationSchema={validationSchema}
                validateOnMount
                onSubmit={async(values, helpers) => {
                    const { resetForm } = helpers;
                    const ok = await ConfirmDialog(DEMAND_ACTIONS.UPLOAD_LEGAL_CONTRACT);
                    if (!ok.confirmed) return false
                    setIsSubmit(true)
                    try {
                        const payload = {action:DEMAND_ACTIONS.UPLOAD_LEGAL_CONTRACT,stateData: {...values}}
                        const res = await props?.addDemandAction(payload, requestId);
                        if (!res) {
                            props.openAlertPopup({
                                message: "Unable to process Legal Contract Report. Please try again.",
                                image: IMAGES.error,
                            });
                            return;
                        }
                        await handelServiceDetailapi();
                        props.openAlertPopup({
                            message: "Duly signed Order Form shared with customer successfully.",
                            image: IMAGES.success,
                        });
                        resetForm();
                    } catch (error){
                         props?.openAlertPopup({
                            message:"An error occurred while processing your request. Please try again later.",
                            image: IMAGES.error,
                        });
                    } finally {
                        setIsSubmit(false);
                    }
                }}
            >
                {({ isValid, dirty, isSubmitting, errors, touched, setFieldValue, values }) => {
                    return (
                        <Form noValidate className={styles.form}>
                            <div className={styles.subform}>
                                <div className={styles.headtxt}>Upload Order Form </div>
                                <div className={styles.infoNote}>The customer-signed order form has been shared with the VGEL team. Upload the duly signed order form here once available. The customer will be notified automatically.</div>
                                <ImageUpload
                                    name="files"
                                    value={values.files}
                                    label="Supporting Attachments"
                                    setFieldValue={setFieldValue}
                                    optional={false}
                                    shoInlineError={false}
                                    feasibility={values.feasibility}
                                    isUploadReport={true}
                                />
                                {/* {isError && <div className={styles.fileSizeErrormsg}>{isError}</div>} */}
                            </div>
                            <div className={styles.actions}>
                                <Submit
                                    type="submit"
                                    disabled={isSubmitting || !(isValid && dirty)}
                                    style={styles.submit}
                                    isSubmitting={isSubmit}
                                    title={"Upload"}
                                />
                            </div>
                        </Form>
                    );
                }}
            </Formik>
        </div>
        {/* <div className={`${styles.moduledescription}`}> <img className={styles.descriptioncircle} src={IMAGES.actionIcon} />Ensure that you download order form and send it to GL Team For Signature via Email and then upload the Signed orderForm back on the Portal .</div> */}
        </>
    );
};

const mapStateToProps = (state) => {
  return null;
};

const mapDispatchToProps = (dispatch) => {
  return {
    addDemandAction: (payload,id)=>{
      return dispatch(addDemandAction(payload,id))
    },
    openAlertPopup: (alertHeader,alertmessage) => {
      return dispatch(openAlertPopup(alertHeader,alertmessage))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LegalContract);